var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{ref:"popup",attrs:{"animation":'scale'}},[_c('div',[_c('div',{staticClass:"redeem-container"},[_c('img',{staticClass:"redeem-img",attrs:{"src":_vm.getCongratulationImage()},on:{"click":_vm.hide}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b04fc50","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/Redeem.vue
// module id = 414
// module chunks = 0